import React, { FC } from 'react';

import { NumericFont } from 'Shared/components';

import { FlexiblePaymentPlanProps } from './types';
import styles from './styles.module.css';

export const FlexiblePaymentPlan: FC<FlexiblePaymentPlanProps> = ({
  frequencyLabel,
  installmentAmount,
  totalPremiumAmount,
}) => {
  const isFullPay = !!frequencyLabel && !!installmentAmount;

  const renderPaymentPlanAmount = (amount: string) => {
    return <NumericFont className={styles.amount} value={amount} />;
  };

  const renderFrequencyPaymentPlan = (
    frequency: string,
    frequencyAmount: string
  ) => {
    return (
      <div className={`${styles.paymentPlanDetails} ${styles.amountWrapper}`}>
        {frequency}:{renderPaymentPlanAmount(frequencyAmount)}
      </div>
    );
  };

  const renderInFullPaymentPlan = (totalAmount: string) => {
    return (
      <div className={`${styles.paymentPlanDetails} ${styles.amountWrapper}`}>
        Total Cost:
        {renderPaymentPlanAmount(totalAmount)}
      </div>
    );
  };

  const generateTestId = (label?: string) => {
    const baseId = 'flexible-payment-plan';

    if (!label) return baseId;

    return `${baseId}-${label.toLowerCase().replace(/\s+/g, '-')}`;
  };

  return (
    <div
      className={styles.paymentPlan}
      data-testid={generateTestId(frequencyLabel)}
    >
      {isFullPay
        ? renderFrequencyPaymentPlan(frequencyLabel, installmentAmount)
        : null}
      {renderInFullPaymentPlan(totalPremiumAmount)}
    </div>
  );
};
